import React, { useState, useEffect } from 'react';
import './Carousel.css'; // We'll update this CSS file

interface CarouselProps {
    children: React.ReactNode[];
    autoPlay?: boolean;
    interval?: number;
    showDots?: boolean;
    showArrows?: boolean;
}

const Carousel: React.FC<CarouselProps> = ({
                                               children,
                                               autoPlay = false,
                                               interval = 3000,
                                               showDots = true,
                                               showArrows = true,
                                           }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [length, setLength] = useState(children.length);

    useEffect(() => {
        setLength(children.length);
    }, [children]);

    useEffect(() => {
        if (!autoPlay) return;

        const timer = setInterval(() => {
            next();
        }, interval);

        return () => clearInterval(timer);
    }, [autoPlay, interval, currentIndex]);

    const next = () => {
        setCurrentIndex(prevIndex =>
            prevIndex === length - 1 ? 0 : prevIndex + 1
        );
    };

    const prev = () => {
        setCurrentIndex(prevIndex =>
            prevIndex === 0 ? length - 1 : prevIndex - 1
        );
    };

    const goToIndex = (index: number) => {
        setCurrentIndex(index);
    };

    return (
        <div className="carousel-container">
            <div className="carousel-content-wrapper">
                <div
                    className="carousel-content"
                    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                    {React.Children.map(children, (child, index) => (
                        <div key={index} className="carousel-item">
                            {child}
                        </div>
                    ))}
                </div>
            </div>

            {(showArrows || showDots) && (
                <div className="carousel-controls">
                    {showArrows && (
                        <button
                            onClick={prev}
                            className="carousel-arrow"
                            aria-label="Previous slide"
                        >
                            &lt;
                        </button>
                    )}

                    {showDots && length > 1 && (
                        <div className="carousel-dots">
                            {Array.from({ length }).map((_, index) => (
                                <button
                                    key={index}
                                    className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                                    onClick={() => goToIndex(index)}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    )}

                    {showArrows && (
                        <button
                            onClick={next}
                            className="carousel-arrow"
                            aria-label="Next slide"
                        >
                            &gt;
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default Carousel;